import { IRootState } from '../../../store'
import { IPertinentNegativeProcedureOptionsState } from '../store/options.types'

export const getPnProcedureOptionsSelector = (state: IRootState): IPertinentNegativeProcedureOptionsState =>
  state.options.pnProcedureOptions
